import { Helper } from '../../../../../classes/helper'
import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { brush, roofTopBar } from '../../model/helper/verandaDimensions'
import { Keys } from '../../../../../hooks/state/utlility/utils'
import { WallSideGlass } from '../../window/side/glass/WallSideGlass'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { ColorRepresentation } from 'three'
import { SlidingDoorHandleWithLock } from './SlidingDoorHandleWithLock'
import { useVerandaSelector } from '../../../../..'

interface Props {
  position: any
  height: number
  frame: boolean
  windowWitdth?: number
  total?: number
  indexZ?: number
}

export const Window = ({
  position,
  height,
  frame,
  windowWitdth = 0,
  total = 0,
  indexZ = 0,
}: Props): JSX.Element => {
  const {
    type,
    sidwallTyp,
    windowsSideWidth,
    brushTyp,
    windowsSideTotal,
    doorTexture,
  } = useSidewall()
  const windowWidth = windowWitdth ? windowWitdth : windowsSideWidth
  const { color } = useRoof()
  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)
  const glasLogsHeight = 0.05
  const windowsPositionX =
    (type === Keys.Seitenwände.Values.SeitenwandRechts.key
      ? -sidwallTyp.glas
      : sidwallTyp.glas) * (total ? total : windowsSideTotal)

  return (
    <group position={[windowsPositionX, 0, 0]}>
      {frame && (
        <>
          {[...Array(2)].map((_, index) => {
            return (
              <>
                <mesh
                  key={`window${index}frameVertical`}
                  castShadow={true}
                  position={[
                    position[0] - 0.005,
                    height / 2,
                    position[2] -
                      (windowWidth - 0.018) / 2 +
                      (windowWidth - 0.018) * index,
                  ]}
                  rotation={[
                    Helper.convertAngleToRadiant(90),
                    Helper.convertAngleToRadiant(0),
                    Helper.convertAngleToRadiant(0),
                  ]}
                  receiveShadow={true}
                >
                  <boxGeometry
                    args={[
                      sidwallTyp.glas + 0.02,
                      glasLogsHeight,
                      height - glasLogsHeight * 3,
                    ]}
                  />
                  <CachedMeshPhysicalMaterial color={color} />
                </mesh>
              </>
            )
          })}

          {[...Array(2)].map((_, index) => {
            return (
              <mesh
                key={`window${index}frameHorizontal`}
                castShadow={true}
                receiveShadow={true}
                position={[
                  position[0] - sidwallTyp.glas / 2,
                  (height - glasLogsHeight) * index + (index ? 0 : 0.07),
                  position[2],
                ]}
                rotation={[
                  Helper.convertAngleToRadiant(0),
                  Helper.convertAngleToRadiant(0),
                  Helper.convertAngleToRadiant(90),
                ]}
              >
                <boxGeometry
                  args={[
                    glasLogsHeight,
                    sidwallTyp.glas + 0.02,
                    windowWidth + 0.036,
                  ]}
                />
                <CachedMeshPhysicalMaterial color={color} />
              </mesh>
            )
          })}
        </>
      )}
      {!frame && (
        <>
          {[...Array(2)].map((_, index) => {
            return (
              <mesh
                key={`window${index}Horizontal`}
                castShadow={true}
                receiveShadow={true}
                position={[
                  position[0] - sidwallTyp.glas / 2,
                  (height - glasLogsHeight) * index + (index ? 0 : 0.07),
                  position[2],
                ]}
                rotation={[
                  Helper.convertAngleToRadiant(0),
                  Helper.convertAngleToRadiant(0),
                  Helper.convertAngleToRadiant(90),
                ]}
              >
                <boxGeometry
                  args={[
                    glasLogsHeight,
                    sidwallTyp.glas + 0.01,
                    windowWidth + 0.036,
                  ]}
                />
                <CachedMeshPhysicalMaterial color={color} />
              </mesh>
            )
          })}
        </>
      )}
      <WallSideGlass
        height={height - glasLogsHeight * 2}
        cut={true}
        windowsSideWidth={windowWidth + 0.03}
        position={position}
        roughness={total ? doorTexture.roughness : 0.3}
        opacity={total ? doorTexture.opacity : 0.4}
        isGlass={true}
      />

      {brushTyp && (
        <mesh
          position={[position[0], height / 2, position[2] + windowWidth / 2]}
          rotation={[
            Helper.convertAngleToRadiant(0),
            Helper.convertAngleToRadiant(90),
            Helper.convertAngleToRadiant(90),
          ]}
        >
          <boxGeometry
            args={[
              height - sidwallTyp.log.width * 2 - glasLogsHeight,
              brush.width,
              brush.depth,
            ]}
          />
          <CachedMeshPhysicalMaterial
            color={brush.color as ColorRepresentation}
            opacity={1}
            roughness={1}
          />
        </mesh>
      )}
    </group>
  )
}
